import type { ProjectId } from 'owa-timestream-types';
import getProjectsInLocalStorage from './getProjectsInLocalStorage';

export default function getIsCanvasLockedFromLocalStorage(projectId: ProjectId): boolean {
    try {
        const { isCanvasLocked } = getProjectsInLocalStorage()[projectId];
        return typeof isCanvasLocked === 'boolean' && isCanvasLocked;
    } catch {}

    // by default assume false as to not block user actions
    return false;
}
